import React, { useState, useEffect } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Button, Form, Input, Select, Upload, message } from "antd";
import { useNavigate, useParams } from "react-router";
import TextArea from "antd/es/input/TextArea";

const AdminManagerUpdate = () => {
    const [fileList, setFileList] = useState([]); 
    const [currentImage, setCurrentImage] = useState(""); 
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const { id: managerId } = useParams();
    const apiUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
  
      const fetchManager = async () => {
        try {
          const response = await fetch(
            `${apiUrl}/api/manager/${managerId}`
          );
          if (response.ok) {
            const data = await response.json();
            form.setFieldsValue({
              name: data.name || "",
              department: data.department || "",
              text1: data.text1 || "",
              text2: data.text2 || "",
              boardType: data.boardType || "",
            });
  
            setCurrentImage(data.img || "");
          } else {
            message.error("Yönetici bilgisi alınamadı!");
          }
        } catch (error) {
          console.error(error);
          message.error("Sunucudan yanıt alınamadı.");
        }
      };
  
      fetchManager();
    }, [managerId, form,apiUrl]);
  
  
    const normFile = (e) => (Array.isArray(e) ? e : e && e.fileList);
  
    const handleFileChange = ({ fileList }) => setFileList(fileList);
  
    const handleSubmit = async (values) => {
      const { name, department, text1, text2 } = values;
  
      const formData = new FormData();
      formData.append("name", name);
      formData.append("department", department);
      formData.append("text1", text1);
      formData.append("text2", text2);
      formData.append("boardType", values.boardType);

      if (fileList.length > 0 && fileList[0].originFileObj) {
        formData.append("img", fileList[0].originFileObj);
      } else {
        formData.append("existingImg", currentImage);
      }
  
      try {
        const response = await fetch(
          `${apiUrl}/api/manager/${managerId}`,
          {
            method: "PUT",
            body: formData,
          }
        );
  
        if (response.ok) {
          message.success("Çalışan başarıyla güncellendi!");
          navigate("/admin/manager");
        } else {
          message.error("Bir hata oluştu.");
        }
      } catch (error) {
        console.error("Error:", error);
        message.error("Sunucu hatası oluştu.");
      }
    };
  return (
    <>
         {currentImage && (
           <div style={{ marginBottom: 16, margin: "0 auto" }}>
             <img
               src={currentImage}
               alt="Mevcut Profil Resmi"
               style={{ width: 150, height: 150, borderRadius: "50%", objectFit: "cover" }}
             />
           </div>
         )}
        <Form
  form={form}
  labelCol={{ span: 4 }}
  wrapperCol={{ span: 14 }}
  layout="horizontal"
  onFinish={handleSubmit}
  style={{ maxWidth: 600, margin: "0 auto" }}
>
  <Form.Item
    label="İsim/Soyisim"
    name="name"
    rules={[{ required: true, message: "Lütfen isim giriniz!" }]}
  >
    <Input />
  </Form.Item>

  <Form.Item
    label="Makam"
    name="department"
    rules={[{ required: true, message: "Lütfen bir makam giriniz!" }]}
  >
    <Input />
  </Form.Item>
  <Form.Item
    label="Hakkında 1"
    name="text1"
    rules={[{ required: true, message: "Lütfen bir hakkında yazısı giriniz!" }]}
  >
    <TextArea />
  </Form.Item>
  <Form.Item
    label="Hakkında 2"
    name="text2"
    rules={[{ required: true, message: "Lütfen bir hakkında yazısı giriniz!" }]}
  >
    <TextArea />
  </Form.Item>

       <Form.Item label="Kurul Türü" name="boardType">
         <Select placeholder="Bir Kurul Türü Seçin">
           <Select.Option value="management">Yönetim Kurulu</Select.Option>
           <Select.Option value="audit">Denetim Kurulu</Select.Option>
           <Select.Option value="unit">Birim Sorumlusu</Select.Option>
     
         </Select>
       </Form.Item>

  <Form.Item
    getValueFromEvent={normFile}
    label="Yeni Profil Resmi"
    valuePropName="fileList"
    name="img"
  >
    <Upload
      listType="picture-card"
      fileList={fileList}
      onChange={handleFileChange}
      beforeUpload={() => false}
    >
      {fileList.length === 0 && (
        <button style={{ border: 0, background: "none" }} type="button">
          <PlusOutlined />
          <div style={{ marginTop: 8 }}>Upload</div>
        </button>
      )}
    </Upload>
  </Form.Item>

  <Form.Item wrapperCol={{ offset: 4, span: 14 }}>
    <Button type="primary" htmlType="submit">
      Yönetici Güncelle
    </Button>
  </Form.Item>
</Form>

       </>
  )
}

export default AdminManagerUpdate